export enum PostMessageEvent {
  CHECK_TABLE_EXISTENCE = 'checkTableExistence',
  SYNC_BLOCK_APP_CONFIG = 'syncBlockAppConfig',
  SEND_READY_STATUS = 'sendReadyStatus',
  REFRESH_MODAL = 'refreshModal',
  REFRESH_MODAL_CHECK = 'refreshModalCheck',
  CLOSE_MODAL = 'closeModal',
  CLOSE_MODAL_CHECK = 'closeModalCheck',
  REFRESH_APP_CONFIG = 'refreshAppConfig',
  UPDATE_EXPANDED_CONFIG = 'updateExpandedConfig',
}
